import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons';
import { Tag } from '@rocketlane/ui';
import { SourcePageTemplate } from 'api/custom-section/types';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useSourceIntoText } from './sources-into-text';

const Wrapper = styled.div``;

interface Props {
  sources: SourcePageTemplate[];
  onClick?: () => void;
  className?: string;
}
export const PeoplePageDerivedSectionSources: FC<Props> = ({
  sources,
  onClick,
  className,
}) => {
  const { sourceToDisplay, wrapperRef } = useSourceIntoText(sources);

  return (
    <Wrapper ref={wrapperRef} onClick={onClick} className={className}>
      <Tag
        color="blue"
        variant="basic"
        icon={
          <FontAwesomeIcon
            icon={faGlobe}
            size={16}
            iconSize={12}
            color={'transparent'}
          />
        }
        onClick={onClick}
        className={className}
      >
        {sources.length > 0 ? (
          <FormattedMessage
            id="rich_text_editor.sections.company_page_source_derived_section.sources.label"
            values={{
              sources: sourceToDisplay,
            }}
          />
        ) : (
          <FormattedMessage id="rich_text_editor.sections.people_page_derived_section.sources.default.label" />
        )}
      </Tag>
    </Wrapper>
  );
};
